module.exports = __webpack_public_path__ + "static/img/sec1-cont02-bg.528a30e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution/sec1-cont02-bg.png
// module id = yKHJ
// module chunks = 0